export default __webpack_public_path__ + "static/media/29.d537730c.png";